// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".course-wrapper[data-v-8f52a864]{position:relative;height:auto;margin:0 auto}.course-wrapper .course-content[data-v-8f52a864]{margin:14px auto 0;display:flex;width:1200px}.course-wrapper .course-content .course-data[data-v-8f52a864]{flex:1}.course-wrapper .course-content .course-data .course-header[data-v-8f52a864]{border-bottom:1px solid #ddd}.course-wrapper .course-content .course-data .course-list[data-v-8f52a864]{padding:20px 0 30px;display:flex;flex-wrap:wrap}", ""]);
// Exports
module.exports = exports;
